export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/valueOf.js
// module id = 577
// module chunks = 0